// src/pages/BizKimizPage.js
import React from "react";
import GlobalStyles from "@mui/material/GlobalStyles";
import {
  Box, Container, Grid, Paper, Stack, Typography, Button,
  Avatar, Dialog, DialogContent, IconButton, TextField, Switch,
  FormControlLabel, Divider, Tooltip, Table, TableBody, TableCell,
  TableHead, TableRow, Snackbar, Alert
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { motion } from "framer-motion";
import ResimUpload from "../ResimUpload";
import { API_BASE } from "../config";

/* ====== RENKLER ====== */
const COLORS = {
  blue: "#2563eb",
  orange: "#f59e0b",
  green: "#16a34a",
  pink: "#db2777",
  cyan: "#0891b2",
  amber: "#d97706",
  indigo: "#4f46e5",
  red: "#dc2626",
  lightBgTop: "#f8fafc",
  lightBgBottom: "#eef2ff",
  card: "#ffffff",
  border: "rgba(0,0,0,0.08)",
  text: "#0f172a"
};
const GRADIENT_BRAND = `linear-gradient(135deg, ${COLORS.blue}, ${COLORS.orange})`;


const miniTitle = {
  fontWeight: 900,
  mb: 1,
  px: 1.3,
  py: 0.6,
  display: "inline-block",
  textTransform: "uppercase",
  letterSpacing: 0.8,
  borderRadius: 2,
  fontSize: "0.9rem",
background: COLORS.blue,
  color: "#fff",
};









/* ====== DİL ====== */
const ALLOWED = ["tr", "en", "de"];
const T = {
  tr: {
    title: "BİZ KİMİZ",
    subtitle: "Hikayemiz, değerlerimiz ve yapımız",
    ctaAbout: "Hakkımızda",
    ctaMission: "Misyonumuz",
    ctaVision: "Vizyonumuz",

    metrics: {
      teams: "Faaliyet Sayısı",
      trophies: "Başarı & Ödül",
      members: "Topluluk & Üye Sayısı",
      years: "Yıl & Deneyim"
    },

    blocks: {
      mission: "MİSYON",
      vision: "VİZYON",
      history: "BİZ KİMİZ",
      counters: "BAŞARILAR (SAYISAL)",
      people: "KİŞİLER / GÖREVLİLER",
      gallery: "GALERİ",
      controls: "CANLI İÇERİK AYARLARI",
      preview: "ÖNİZLEME / LİSTELEME"
    },

    fields: {
      mission: "Misyon metni",
      vision: "Vizyon metni",
      history: "Geçmiş / Hikayemiz",
      teams: "Faaliyet Sayısı",
      trophies: "Başarı & Ödül",
      members: "Topluluk & Üye Sayısı",
      years: "Yıl & Deneyim",
      personName: "Ad Soyad",
      personRole: "Görev / Yetki",
      personDesc: "Açıklama",
      personLink: "Fotoğraf Linki",
      galleryName: "Ad",
      galleryDesc: "Açıklama",
      galleryLink: "Link"
    },

    labels: {
      active: "Aktif",
      addPerson: "Kişi Ekle",
      addPhoto: "Satır Ekle",
      save: "Kaydet",
      copy: "Kopyala",
      saved: "Verileriniz kaydedildi.",
      failed: "Kayıt başarısız.",
      loading: "Kaydediliyor...",
      delete: "Sil"
    }
  },

  en: {
    title: "Who We Are",
    subtitle: "Our story, values and structure",
    ctaAbout: "About Us",
    ctaMission: "Our Mission",
    ctaVision: "Our Vision",

    metrics: {
      teams: "Activity Count",
      trophies: "Achievements & Awards",
      members: "Community & Members",
      years: "Years & Experience"
    },

    blocks: {
      mission: "MISSION",
      vision: "VISION",
      history: "HISTORY / STORY",
      counters: "ACHIEVEMENTS (NUMBERS)",
      people: "PEOPLE / OFFICIALS",
      gallery: "GALLERY",
      controls: "LIVE CONTENT SETTINGS",
      preview: "PREVIEW / LISTING"
    },

    fields: {
      mission: "Mission text",
      vision: "Vision text",
      history: "History / Story",
      teams: "Activity Count",
      trophies: "Achievements & Awards",
      members: "Community & Members",
      years: "Years & Experience",
      personName: "Full Name",
      personRole: "Role / Authority",
      personDesc: "Description",
      personLink: "Photo Link",
      galleryName: "Name",
      galleryDesc: "Description",
      galleryLink: "Link"
    },

    labels: {
      active: "Active",
      addPerson: "Add Person",
      addPhoto: "Add Row",
      save: "Save",
      copy: "Copy",
      saved: "Saved successfully.",
      failed: "Save failed.",
      loading: "Saving...",
      delete: "Delete"
    }
  },

  de: {
    title: "Wer wir sind",
    subtitle: "Unsere Geschichte, Werte und Struktur",
    ctaAbout: "Über uns",
    ctaMission: "Unsere Mission",
    ctaVision: "Unsere Vision",

    metrics: {
      teams: "Anzahl der Aktivitäten",
      trophies: "Erfolg & Auszeichnungen",
      members: "Community & Mitgliederzahl",
      years: "Jahre & Erfahrung"
    },

    blocks: {
      mission: "MISSION",
      vision: "VISION",
      history: "GESCHICHTE",
      counters: "ERFOLGE (ZAHLEN)",
      people: "PERSONEN / VERANTWORTLICHE",
      gallery: "GALERIE",
      controls: "LIVE-INHALT EINSTELLUNGEN",
      preview: "VORSCHAU / LISTE"
    },

    fields: {
      mission: "Missions-Text",
      vision: "Visions-Text",
      history: "Geschichte",
      teams: "Anzahl der Aktivitäten",
      trophies: "Erfolg & Auszeichnungen",
      members: "Community & Mitgliederzahl",
      years: "Jahre & Erfahrung",
      personName: "Vollständiger Name",
      personRole: "Rolle / Befugnis",
      personDesc: "Beschreibung",
      personLink: "Foto-Link",
      galleryName: "Name",
      galleryDesc: "Beschreibung",
      galleryLink: "Link"
    },

    labels: {
      active: "Aktiv",
      addPerson: "Person hinzufügen",
      addPhoto: "Zeile hinzufügen",
      save: "Speichern",
      copy: "Kopieren",
      saved: "Erfolgreich gespeichert.",
      failed: "Speichern fehlgeschlagen.",
      loading: "Speichern...",
      delete: "Löschen"
    }
  }
};

function useUiTexts() {
  const [uiLang, setUiLang] = React.useState(
    () => (localStorage.getItem("app_lang") || "tr").slice(0, 2).toLowerCase()
  );
  React.useEffect(() => {
    const sync = () => {
      const l = (localStorage.getItem("app_lang") || "tr").slice(0, 2).toLowerCase();
      setUiLang(ALLOWED.includes(l) ? l : "tr");
    };
    window.addEventListener("app_lang_change", sync);
    window.addEventListener("storage", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener("app_lang_change", sync);
      window.removeEventListener("storage", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);
  const lang = ALLOWED.includes(uiLang) ? uiLang : "tr";
  return { TT: T[lang], lang };
}

/* ====== VARSAYILAN İÇERİK ====== */
const defaults = {
  mission: "", missionActive: true,
  vision: "", visionActive: true,
  history: "", historyActive: true,
  countersActive: true,
  counters: { teams: 0, trophies: 0, members: 0, years: 0 },
  peopleActive: true,
  people: [],
  galleryActive: true,
  gallery: [],
};

const STORAGE_KEY = "about_content_by_lang_v6";
function loadByLang(lang) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const all = raw ? JSON.parse(raw) : {};
    return { ...all, [lang]: { ...defaults, ...(all?.[lang] || {}) } };
  } catch {
    return { [lang]: defaults };
  }
}
function saveByLang(lang, data) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const all = raw ? JSON.parse(raw) : {};
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...all, [lang]: data }));
  } catch {}
}

/* ====== YARDIMCILAR ====== */
const bust = (u, v) => (u ? `${u}${u.includes("?") ? "&" : "?"}v=${v}` : "");
const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};
const api = (path, options = {}) =>
  fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      ...(options.headers || {}),
    },
  });

/* ====== UI HELPERS ====== */
const MotionButton = motion(Button);
const MotionPaper = motion(Paper);
const MotionImg = motion("img");
function Section({ title, children }) {
  return (
    <Box sx={{ mt: 4 }}>
      
<Typography
  variant="h4"
  sx={{
    fontWeight: 900,
    mb: 2,
    px: 2,
    py: 1,
    display: "inline-block",
    textTransform: "uppercase",
    letterSpacing: 1,
    borderRadius: 2,
    background: "linear-gradient(90deg, #2563eb, #f59e0b)",
    color: "#fff",
    boxShadow: "0 4px 14px rgba(0,0,0,0.12)"
  }}
>
  {title}
</Typography>



      {children}
    </Box>
  );
}
function BigCounter({ value, label, gradient }) {
  return (
    <Paper
      sx={{
        p: 4,
        borderRadius: 4,
        color: "#fff",
        background: gradient,
        boxShadow: "0 16px 40px rgba(0,0,0,0.18)",
        textAlign: "center",
        minHeight: 170
      }}
    >
      <Typography variant="h2" sx={{ fontWeight: 900, lineHeight: 1 }}>{value}</Typography>
 <Typography
  sx={{
    mt: 1.2,
    fontWeight: 900,
    textTransform: "uppercase",
    letterSpacing: 0.6,
    fontSize: {
      xs: "0.70rem",    // telefon
      sm: "0.80rem",    // tablet
      md: "0.95rem"     // normal desktop
    }
  }}
>
  {label}
</Typography>


    </Paper>
  );
}

/* ====== Resim Hücresi — Etkinlikler ile aynı mantık ====== */
function ImageCell({ value, onChange, label = "📤 Yükle", rounded = false, ver, setVer }) {
  const preview = value ? bust(value, ver) : "";
  return (
   <Stack
  direction="row"
  spacing={1}
  alignItems="center"
  sx={{
    width: "100%",
    maxWidth: "100%",     // ← Sağdan taşmayı keser
    overflow: "hidden"    // ← Ekran dışına çıkamaz
  }}
>

    <Avatar
  variant={rounded ? "rounded" : "circular"}
  src={preview}
  alt="preview"
  sx={{
    width: { xs: 56, sm: 72 },
    height: { xs: 56, sm: 72 },
    border: `1px solid ${COLORS.border}`
  }}
/>


     <Box
  sx={{
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gap: 1,
    alignItems: "center",
    flex: 1,
    minWidth: 0   // ← TAŞMAYI %100 BİTİREN ÇÖZÜM
  }}
>

        <TextField
          size="small"
          fullWidth
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://..."
        />
        <ResimUpload
          label={label}
          defaultPreview={value}
          onUpload={(url) => {
            onChange(url);
            setVer((v) => v + 1);
          }}
        />
      </Box>
    </Stack>
  );
}

function MobilePersonCard({ m, idx, setPersonValue, removePerson, TT, ver, setVer }) {
  return (
    <Paper sx={{ p: 2, mb: 2, borderRadius: 3, display: { xs: "block", md: "none" } }}>
      <Stack spacing={2}>
        <ImageCell
          value={m.photoUrl || ""}
          rounded={false}
          ver={ver}
          setVer={setVer}
          onChange={(finalUrl) => {
            setPersonValue(idx, "photoUrl", finalUrl);
            setPersonValue(idx, "link", finalUrl);
          }}
        />

        <TextField
          size="small"
          fullWidth
          label={TT.fields.personName}
          value={m.name || ""}
          onChange={(e) => setPersonValue(idx, "name", e.target.value)}
        />

        <TextField
          size="small"
          fullWidth
          label={TT.fields.personRole}
          value={m.role || ""}
          onChange={(e) => setPersonValue(idx, "role", e.target.value)}
        />

        <TextField
          size="small"
          fullWidth
          label={TT.fields.personDesc}
          value={m.desc || ""}
          onChange={(e) => setPersonValue(idx, "desc", e.target.value)}
        />

        <Stack direction="row" spacing={1} alignItems="center">
          <TextField
            size="small"
            fullWidth
            label={TT.fields.personLink}
            value={m.link || ""}
            onChange={(e) => setPersonValue(idx, "link", e.target.value)}
          />
          {m.link && (
            <IconButton size="small" onClick={() => navigator.clipboard.writeText(m.link)}>
              <ContentCopyIcon />
            </IconButton>
          )}
        </Stack>

        <Button
          color="error"
          startIcon={<DeleteIcon />}
          variant="contained"
          onClick={() => removePerson(idx)}
        >
          {TT.labels.delete}
        </Button>
      </Stack>
    </Paper>
  );
}




/* ====== SAYFA ====== */
export default function BizKimizPage() {
  const { TT, lang } = useUiTexts();
  const [openImg, setOpenImg] = React.useState(null);
  const [content, setContent] = React.useState(() => loadByLang(lang)[lang]);
  const [ver, setVer] = React.useState(0);
  const [saving, setSaving] = React.useState(false);
  const [snack, setSnack] = React.useState({ open: false, msg: "", severity: "success" });

  // Dil değişince localStorage içeriğini yükle
  React.useEffect(() => { setContent(loadByLang(lang)[lang]); }, [lang]);

  // Autosave localStorage
  const saveTimeout = React.useRef();
  React.useEffect(() => {
    clearTimeout(saveTimeout.current);
    saveTimeout.current = setTimeout(() => saveByLang(lang, content), 400);
    return () => clearTimeout(saveTimeout.current);
  }, [content, lang]);

  // Sunucudan çek (gelen linkleri DOKUNMADAN al)
  React.useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const r = await api(`/bizkimiz?lang=${lang}`, { method: "GET" });
        if (!r.ok) return;
        const data = await r.json();
        if (!mounted) return;

        const incoming = {
          mission: data.mission ?? "",
          missionActive: data.missionActive ?? true,
          vision: data.vision ?? "",
          visionActive: data.visionActive ?? true,
          history: data.history ?? "",
          historyActive: data.historyActive ?? true,
          countersActive: data.countersActive ?? true,
          peopleActive: data.peopleActive ?? true,
          galleryActive: data.galleryActive ?? true,
          counters: {
            teams: data.counters?.teams ?? 0,
            trophies: data.counters?.trophies ?? 0,
            members: data.counters?.members ?? 0,
            years: data.counters?.years ?? 0,
          },
          people: (data.people || []).map(p => ({
            name: p.name || "",
            role: p.role || "",
            desc: p.desc || "",
            link: p.photoUrl || p.link || "",
            photoUrl: p.photoUrl || p.link || "",
          })),
          gallery: (data.gallery || []).map(g => ({
            name: g.name || "",
            desc: g.desc || "",
            url: g.url || "",
          })),
        };

        setContent(incoming);
        saveByLang(lang, incoming);
        setVer(v => v + 1);
      } catch {
        // bağlanamazsa local ile devam
      }
    })();
    return () => { mounted = false; };
  }, [lang]);

  // FIELD helper
  const onField = (path, val) => {
    setContent(prev => {
      const next = { ...prev };
      const parts = path.split(".");
      let ref = next;
      for (let i = 0; i < parts.length - 1; i++) {
        ref[parts[i]] = { ...(ref[parts[i]] || {}) };
        ref = ref[parts[i]];
      }
      ref[parts[parts.length - 1]] = val;
      return next;
    });
  };
  const copy = (txt) => navigator.clipboard?.writeText(txt);


function MobileGalleryCard({ g, idx, setGalleryValue, removeGalleryItem, TT, ver, setVer }) {
  return (
    <Paper sx={{ p: 2, mb: 2, borderRadius: 3, display: { xs: "block", md: "none" } }}>
      <Stack spacing={2}>
        <ImageCell
          value={g.url || ""}
          rounded={true}
          ver={ver}
          setVer={setVer}
          onChange={(finalUrl) => setGalleryValue(idx, "url", finalUrl)}
        />

        <TextField
          size="small"
          fullWidth
          label={TT.fields.galleryName}
          value={g.name || ""}
          onChange={(e) => setGalleryValue(idx, "name", e.target.value)}
        />

        <TextField
          size="small"
          fullWidth
          label={TT.fields.galleryDesc}
          value={g.desc || ""}
          onChange={(e) => setGalleryValue(idx, "desc", e.target.value)}
        />

        <Stack direction="row" spacing={1} alignItems="center">
          <TextField
            size="small"
            fullWidth
            label={TT.fields.galleryLink}
            value={g.url || ""}
            onChange={(e) => setGalleryValue(idx, "url", e.target.value)}
          />
          {g.url && (
            <IconButton size="small" onClick={() => navigator.clipboard.writeText(g.url)}>
              <ContentCopyIcon />
            </IconButton>
          )}
        </Stack>

        <Button
          color="error"
          startIcon={<DeleteIcon />}
          variant="contained"
          onClick={() => removeGalleryItem(idx)}
        >
          {TT.labels.delete}
        </Button>
      </Stack>
    </Paper>
  );
}



  /* ========== PEOPLE OPS ========== */
  const addPerson = () => {
    onField("people", [ ...(content.people || []), { name: "", role: "", desc: "", link: "", photoUrl: "" } ]);
  };
  const removePerson = (idx) => {
    const arr = [ ...(content.people || []) ];
    arr.splice(idx, 1);
    onField("people", arr);
  };
  const setPersonValue = (idx, key, value) => {
    const arr = [ ...(content.people || []) ];
    arr[idx] = { ...(arr[idx] || {}), [key]: value };
    onField("people", arr);
  };

  /* ========== GALLERY OPS ========== */




  const addGalleryItem = () => {
    onField("gallery", [ ...(content.gallery || []), { name: "", desc: "", url: "" } ]);
  };
  const removeGalleryItem = (idx) => {
    const arr = [ ...(content.gallery || []) ];
    arr.splice(idx, 1);
    onField("gallery", arr);
  };
  const setGalleryValue = (idx, key, value) => {
    const arr = [ ...(content.gallery || []) ];
    arr[idx] = { ...(arr[idx] || {}), [key]: value };
    onField("gallery", arr);
  };

  /* ========== KAYDET (PUT /bizkimiz) ========== */
  const saveToServer = async () => {
    try {
      setSaving(true);
      const payload = {
        lang,
        mission: content.mission || "",
        missionActive: !!content.missionActive,
        vision: content.vision || "",
        visionActive: !!content.visionActive,
        history: content.history || "",
        historyActive: !!content.historyActive,
        countersActive: !!content.countersActive,
        peopleActive: !!content.peopleActive,
        galleryActive: !!content.galleryActive,
        counters: {
          teams: Number(content.counters?.teams) || 0,
          trophies: Number(content.counters?.trophies) || 0,
          members: Number(content.counters?.members) || 0,
          years: Number(content.counters?.years) || 0,
        },
        people: (content.people || []).map(p => {
          const u = p.photoUrl || p.link || "";
          return { name: p.name || "", role: p.role || "", desc: p.desc || "", link: u, photoUrl: u };
        }),
        gallery: (content.gallery || []).map(g => ({
          name: g.name || "",
          desc: g.desc || "",
          url: g.url || "",
        })),
      };

      const r = await api("/bizkimiz", { method: "PUT", body: JSON.stringify(payload) });
      if (!r.ok) throw new Error("PUT failed");
      await r.json();

      setContent(prev => ({ ...prev }));
      saveByLang(lang, { ...payload });
      setSnack({ open: true, msg: TT.labels.saved, severity: "success" });
    } catch (e) {
      setSnack({ open: true, msg: TT.labels.failed, severity: "error" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <GlobalStyles styles={{
        body: { background: `linear-gradient(180deg, ${COLORS.lightBgTop}, ${COLORS.lightBgBottom})` },
        ".MuiSnackbarContent-message": { fontSize: "1.05rem", fontWeight: 800 },
        ".RaNotification-content": { fontSize: "1.05rem", fontWeight: 800 },
      }} />

<Box
  sx={{
    ml: { xs: 0, md: "6px" },
    width: "100%",
    px: { xs: 0, md: 0 },
    pb: 6,
  }}
>
        {/* HERO */}
<Box
  sx={{
    background: GRADIENT_BRAND,
    color: "#fff",
    pt: { xs: 4, md: 6 },
    pb: { xs: 4, md: 5 },
    mb: { xs: 1, md: 3 },
    borderBottom: `1px solid ${COLORS.border}`,
    width: "100%",
    mx: "0px",
  }}
>
          <Container maxWidth="xl">
            <Typography variant="h3" sx={{ fontWeight: 900, textTransform: "uppercase", letterSpacing: 0.6 }}>
              {TT.title}
            </Typography>
            <Typography variant="h6" sx={{ mt: 1.5, opacity: 0.95 }}>
              {TT.subtitle}
            </Typography>

            <Stack direction={{ xs: "column", sm: "row" }} spacing={2.5} sx={{ mt: 3 }}>
              <motion.button whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.98 }} />
            </Stack>

            {content.countersActive && (
              <Grid container spacing={2.5} sx={{ mt: 3 }}>
<Grid item xs={12} sm={6} md={6} lg={3}>
                  <BigCounter value={content?.counters?.teams ?? 0} label={TT.metrics.teams}
                    gradient={`linear-gradient(135deg, ${COLORS.indigo}, ${COLORS.cyan})`} />
                </Grid>
<Grid item xs={12} sm={6} md={6} lg={3}>
                  <BigCounter value={content?.counters?.trophies ?? 0} label={TT.metrics.trophies}
                    gradient={`linear-gradient(135deg, ${COLORS.pink}, ${COLORS.red})`} />
                </Grid>
<Grid item xs={12} sm={6} md={6} lg={3}>
                  <BigCounter value={content?.counters?.members ?? 0} label={TT.metrics.members}
                    gradient={`linear-gradient(135deg, ${COLORS.green}, #34d399)`} />
                </Grid>
<Grid item xs={12} sm={6} md={6} lg={3}>
                  <BigCounter value={content?.counters?.years ?? 0} label={TT.metrics.years}
                    gradient={`linear-gradient(135deg, ${COLORS.amber}, #f59e0b)`} />
                </Grid>
              </Grid>
            )}
          </Container>
        </Box>

        <Container maxWidth="xl">
          <Grid container spacing={3} alignItems="flex-start">
            {/* SAĞ AYAR PANELİ */}
            <Grid item xs={12} md={4}>
              <Paper sx={{ p: 2.5, borderRadius: 3, background: "#ffffff", border: `1px solid ${COLORS.border}`, position: "sticky", top: 16 }}>
                <Typography variant="h6" sx={{ fontWeight: 900, color: COLORS.text, mb: 1, textTransform: "uppercase" }}>
                  {TT.blocks.controls} — <small>({lang.toUpperCase()})</small>
                </Typography>

                {/* Mission */}
                <Stack direction="row" alignItems="center" justifyContent="space-between">


                 <Typography sx={miniTitle}>{TT.blocks.mission}</Typography>

                  <FormControlLabel control={<Switch checked={!!content.missionActive} onChange={(e) => onField("missionActive", e.target.checked)} />} label={TT.labels.active} />
                </Stack>
                <TextField value={content.mission || ""} onChange={(e) => onField("mission", e.target.value)} multiline minRows={3} fullWidth placeholder={TT.fields.mission} sx={{ mb: 2 }} />

                <Divider sx={{ my: 2 }} />

                {/* Vision */}
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                 <Typography sx={miniTitle}>{TT.blocks.vision}</Typography>

                  <FormControlLabel control={<Switch checked={!!content.visionActive} onChange={(e) => onField("visionActive", e.target.checked)} />} label={TT.labels.active} />
                </Stack>
                <TextField value={content.vision || ""} onChange={(e) => onField("vision", e.target.value)} multiline minRows={3} fullWidth placeholder={TT.fields.vision} sx={{ mb: 2 }} />

                <Divider sx={{ my: 2 }} />

                {/* History */}
                <Stack direction="row" alignItems="center" justifyContent="space-between">



                <Typography sx={miniTitle}>{TT.blocks.history}</Typography>

                  <FormControlLabel control={<Switch checked={!!content.historyActive} onChange={(e) => onField("historyActive", e.target.checked)} />} label={TT.labels.active} />
                </Stack>
                <TextField value={content.history || ""} onChange={(e) => onField("history", e.target.value)} multiline minRows={4} fullWidth placeholder={TT.fields.history} sx={{ mb: 2 }} />

                <Divider sx={{ my: 2 }} />

                {/* Counters */}
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Typography sx={{ fontWeight: 700, textTransform: "uppercase" }}>{TT.blocks.counters}</Typography>
                  <FormControlLabel control={<Switch checked={!!content.countersActive} onChange={(e) => onField("countersActive", e.target.checked)} />} label={TT.labels.active} />
                </Stack>
       <Grid container spacing={1.5} sx={{ mb: 1 }}>

  <Grid item xs={6}>
    <TextField
      type="number"
      label={TT.fields.teams}
      value={content.counters?.teams ?? 0}
      onChange={(e) => onField("counters.teams", Number(e.target.value))}
      fullWidth
      InputLabelProps={{
        sx: {
          fontSize: { xs: "0.70rem", sm: "0.80rem", md: "0.90rem" }
        }
      }}
    />
  </Grid>

  <Grid item xs={6}>
    <TextField
      type="number"
      label={TT.fields.trophies}
      value={content.counters?.trophies ?? 0}
      onChange={(e) => onField("counters.trophies", Number(e.target.value))}
      fullWidth
      InputLabelProps={{
        sx: {
          fontSize: { xs: "0.70rem", sm: "0.80rem", md: "0.90rem" }
        }
      }}
    />
  </Grid>

  <Grid item xs={6}>
    <TextField
      type="number"
      label={TT.fields.members}
      value={content.counters?.members ?? 0}
      onChange={(e) => onField("counters.members", Number(e.target.value))}
      fullWidth
      InputLabelProps={{
        sx: {
          fontSize: { xs: "0.70rem", sm: "0.80rem", md: "0.90rem" }
        }
      }}
    />
  </Grid>

  <Grid item xs={6}>
    <TextField
      type="number"
      label={TT.fields.years}
      value={content.counters?.years ?? 0}
      onChange={(e) => onField("counters.years", Number(e.target.value))}
      fullWidth
      InputLabelProps={{
        sx: {
          fontSize: { xs: "0.70rem", sm: "0.80rem", md: "0.90rem" }
        }
      }}
    />
  </Grid>

</Grid>


              

                <Divider sx={{ my: 2 }} />

                {/* PEOPLE */}


{(content.people || []).map((m, idx) => (
  <MobilePersonCard
    key={`mobile-person-${idx}`}
    m={m}
    idx={idx}
    setPersonValue={setPersonValue}
    removePerson={removePerson}
    TT={TT}
    ver={ver}
    setVer={setVer}
  />
))}


                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                  <Typography sx={{ fontWeight: 700, textTransform: "uppercase" }}>{TT.blocks.people}</Typography>
                  <FormControlLabel control={<Switch checked={!!content.peopleActive} onChange={(e) => onField("peopleActive", e.target.checked)} />} label={TT.labels.active} />
                </Stack>

                <Paper variant="outlined" sx={{ mb: 1 }}>
<Table size="small" stickyHeader sx={{ display: { xs: "none", md: "table" } }}>
                    <TableHead>
                      <TableRow>
                        <TableCell width={340} sx={{ fontWeight: 800 }}>Foto</TableCell>
                        <TableCell sx={{ fontWeight: 800 }}>{TT.fields.personName}</TableCell>
                        <TableCell sx={{ fontWeight: 800 }}>{TT.fields.personRole}</TableCell>
                        <TableCell sx={{ fontWeight: 800 }}>{TT.fields.personDesc}</TableCell>
                        <TableCell sx={{ fontWeight: 800 }}>{TT.fields.personLink}</TableCell>
<TableCell align="right" sx={{ fontWeight: 800 }}>{TT.labels.delete}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(content.people || []).map((m, idx) => (
                        <TableRow key={`person-${idx}`} sx={{ height: 110 }}>
                          <TableCell>
                            <ImageCell
                              value={m.photoUrl || ""}
                              rounded={false}
                              ver={ver}
                              setVer={setVer}
                              onChange={(finalUrl) => {
                                setPersonValue(idx, "photoUrl", finalUrl);
                                setPersonValue(idx, "link", finalUrl);
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField size="small" fullWidth value={m.name || ""} onChange={(e) => setPersonValue(idx, "name", e.target.value)} />
                          </TableCell>
                          <TableCell>
                            <TextField size="small" fullWidth value={m.role || ""} onChange={(e) => setPersonValue(idx, "role", e.target.value)} />
                          </TableCell>
                          <TableCell>
                            <TextField size="small" fullWidth value={m.desc || ""} onChange={(e) => setPersonValue(idx, "desc", e.target.value)} />
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <TextField
                                size="small"
                                fullWidth
                                value={m.link || ""}
                                onChange={(e) => setPersonValue(idx, "link", e.target.value)}
                              />
                              {m.link && (
                                <Tooltip title={TT.labels.copy}>
                                  <IconButton size="small" onClick={() => copy(m.link)}>
                                    <ContentCopyIcon fontSize="inherit" />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </Stack>
                          </TableCell>
                          <TableCell align="right">
<Tooltip title={TT.labels.delete}>
                              <IconButton color="error" onClick={() => removePerson(idx)} size="small">
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>

                <Button onClick={addPerson} startIcon={<AddIcon />} variant="outlined" sx={{ mb: 2 }}>
                  {TT.labels.addPerson}
                </Button>

                <Divider sx={{ my: 2 }} />

                {/* GALLERY */}
                <Typography sx={{ fontWeight: 700, textTransform: "uppercase", mb: 1 }}>{TT.blocks.gallery}</Typography>

{/* MOBILE GALLERY CARDS */}
{(content.gallery || []).map((g, idx) => (
  <MobileGalleryCard
    key={`mobile-gallery-${idx}`}
    g={g}
    idx={idx}
    setGalleryValue={setGalleryValue}
    removeGalleryItem={removeGalleryItem}
    TT={TT}
    ver={ver}
    setVer={setVer}
  />
))}



                <Paper variant="outlined" sx={{ mb: 1 }}>
<Table size="small" stickyHeader sx={{ display: { xs: "none", md: "table" } }}>
                    <TableHead>
                      <TableRow>
                        <TableCell width={340} sx={{ fontWeight: 800 }}>Foto</TableCell>
                        <TableCell sx={{ fontWeight: 800 }}>{TT.fields.galleryName}</TableCell>
                        <TableCell sx={{ fontWeight: 800 }}>{TT.fields.galleryDesc}</TableCell>
                        <TableCell sx={{ fontWeight: 800 }}>{TT.fields.galleryLink}</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 800 }}>Sil</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(content.gallery || []).map((g, idx) => (
                        <TableRow key={`gallery-${idx}`} sx={{ height: 110 }}>
                          <TableCell>
                            <ImageCell
                              value={g.url || ""}
                              rounded={true}
                              ver={ver}
                              setVer={setVer}
                              onChange={(finalUrl) => setGalleryValue(idx, "url", finalUrl)}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField size="small" fullWidth value={g.name || ""} onChange={(e) => setGalleryValue(idx, "name", e.target.value)} />
                          </TableCell>
                          <TableCell>
                            <TextField size="small" fullWidth value={g.desc || ""} onChange={(e) => setGalleryValue(idx, "desc", e.target.value)} />
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <TextField
                                size="small"
                                fullWidth
                                value={g.url || ""}
                                onChange={(e) => setGalleryValue(idx, "url", e.target.value)}
                              />
                              {g.url && (
                                <Tooltip title={TT.labels.copy}>
                                  <IconButton size="small" onClick={() => copy(g.url)}>
                                    <ContentCopyIcon fontSize="inherit" />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </Stack>
                          </TableCell>
                          <TableCell align="right">
<Tooltip title={TT.labels.delete}>
                              <IconButton size="small" color="error" onClick={() => removeGalleryItem(idx)}>
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>

                <Button onClick={addGalleryItem} startIcon={<AddIcon />} variant="outlined">
                  {TT.labels.addPhoto}
                </Button>

                <Divider sx={{ my: 2 }} />

                {/* Kaydet */}
                <MotionButton
                  startIcon={<SaveIcon />}
                  onClick={saveToServer}
                  variant="contained"
                  size="large"
                  disabled={saving}
                  whileHover={{ scale: 1.04 }}
                  animate={{
                    boxShadow: [
                      "0 0 0 0 rgba(249,115,22,0)",
                      "0 0 30px 6px rgba(249,115,22,0.35)",
                      "0 0 0 0 rgba(249,115,22,0)"
                    ],
                    transition: { repeat: Infinity, duration: 2.1 }
                  }}
                  sx={{ bgcolor: COLORS.orange, fontWeight: 900, px: 4, py: 2, borderRadius: 2 }}
                >
                  {saving ? TT.labels.loading : TT.labels.save}
                </MotionButton>
              </Paper>
            </Grid>

            {/* SOL — ÖNİZLEME */}
            <Grid item xs={12} md={8}>
              <Section title={TT.blocks.preview} />

              {content.missionActive && (
                <Section title={TT.blocks.mission}>
                  <MotionPaper whileHover={{ y: -2 }} transition={{ type: "spring", stiffness: 120 }}
                    sx={{ p: 2.5, borderRadius: 3, background: COLORS.card, border: `1px solid ${COLORS.border}` }}>
                    <Typography sx={{ fontSize: 18, lineHeight: 1.7, color: COLORS.text }}>
                      {content.mission || "—"}
                    </Typography>
                  </MotionPaper>
                </Section>
              )}

              {content.visionActive && (
                <Section title={TT.blocks.vision}>
                  <MotionPaper whileHover={{ y: -2 }} transition={{ type: "spring", stiffness: 120 }}
                    sx={{ p: 2.5, borderRadius: 3, background: COLORS.card, border: `1px solid ${COLORS.border}` }}>
                    <Typography sx={{ fontSize: 18, lineHeight: 1.7, color: COLORS.text }}>
                      {content.vision || "—"}
                    </Typography>
                  </MotionPaper>
                </Section>
              )}

              {content.historyActive && (
                <Section title={TT.blocks.history}>
                  <Paper sx={{ p: 2.5, borderRadius: 3, background: COLORS.card, border: `1px solid ${COLORS.border}` }}>
                    <Typography sx={{ fontSize: 18, lineHeight: 1.7, color: COLORS.text }}>
                      {content.history || "—"}
                    </Typography>
                  </Paper>
                </Section>
              )}

              {content.galleryActive && (
                <Section title={TT.blocks.gallery}>
                  <Grid container spacing={2}>
                    {(content.gallery || []).map((g, i) => (
<Grid item xs={12} sm={6} md={4} key={`gprev-${i}`}>

                        <MotionImg
                          src={bust(g.url, ver)}
                          alt={g.name}
                          style={{
                            width: "100%", height: 220, objectFit: "cover", borderRadius: 12,
                            border: `1px solid ${COLORS.border}`, cursor: "zoom-in"
                          }}
                          whileHover={{ scale: 1.02 }}
onClick={() => setOpenImg(bust(g.url, ver))}
                        />
                        <Typography sx={{ mt: 1, fontWeight: 800, color: COLORS.text, textTransform: "uppercase" }}>
                          {g.name || "—"}
                        </Typography>
                        {g.desc && (
                          <Typography variant="body2" sx={{ color: COLORS.text, opacity: 0.85 }}>
                            {g.desc}
                          </Typography>
                        )}
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography variant="body2" sx={{ maxWidth: 420, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {g.url}
                          </Typography>
                          {g.url && (
                            <Tooltip title={TT.labels.copy}>
                              <IconButton size="small" onClick={() => copy(g.url)}>
                                <ContentCopyIcon fontSize="inherit" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Stack>
                      </Grid>
                    ))}
                  </Grid>
                </Section>
              )}

              {content.peopleActive && (
                <Section title={TT.blocks.people}>
                  <Grid container spacing={2}>
                    {(content.people || []).map((p, i) => (
<Grid item xs={12} sm={6} md={6} key={`pprev-${i}`}>

                        <MotionPaper whileHover={{ y: -4, boxShadow: "0 20px 40px rgba(0,0,0,0.12)" }}
                          transition={{ type: "spring", stiffness: 120 }}
                          sx={{ p: 2, borderRadius: 3, background: COLORS.card, border: `1px solid ${COLORS.border}`, display: "flex", gap: 1.5 }}>
              <Avatar
  src={bust(p.photoUrl, ver)}
  alt={p.name}
  sx={{
    width: 96,
    height: 96,
    cursor: "zoom-in"
  }}
  onClick={() => setOpenImg(bust(p.photoUrl, ver))}
/>
                 <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 900, color: COLORS.text, textTransform: "uppercase" }}>
                              {p.name || "—"}
                            </Typography>
                            <Typography variant="body2" sx={{ opacity: 0.9, color: COLORS.text, fontWeight: 700 }}>
                              {p.role || "—"}
                            </Typography>
                            {p.desc && (
                              <Typography variant="body2" sx={{ mt: 0.5, color: COLORS.text }}>
                                {p.desc}
                              </Typography>
                            )}
                            {(p.photoUrl || p.link) && (
                              <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
                                <Typography variant="caption" sx={{ maxWidth: 460, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {p.photoUrl || p.link}
                                </Typography>
                                <Tooltip title={TT.labels.copy}>
                                  <IconButton size="small" onClick={() => copy(p.photoUrl || p.link)}>
                                    <ContentCopyIcon fontSize="inherit" />
                                  </IconButton>
                                </Tooltip>
                              </Stack>
                            )}
                          </Box>
                        </MotionPaper>
                      </Grid>
                    ))}
                  </Grid>
                </Section>
              )}
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* LIGHTBOX */}
      <Dialog open={!!openImg} onClose={() => setOpenImg(null)} maxWidth="lg">
        <IconButton onClick={() => setOpenImg(null)} sx={{ position: "absolute", right: 8, top: 8, zIndex: 2, bgcolor: "rgba(0,0,0,0.5)", color: "#fff" }}>
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ p: 0, bgcolor: "#000" }}>
          {openImg && <img src={openImg} alt="large" style={{ width: "100%", height: "auto", display: "block" }} />}
        </DialogContent>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snack.open}
        autoHideDuration={2500}
        onClose={() => setSnack(s => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={() => setSnack(s => ({ ...s, open: false }))} severity={snack.severity} variant="filled">
          {snack.msg}
        </Alert>
      </Snackbar>
    </>
  );
}
